// Server
export { createServer } from "./server.js";
export type {
  CustomMethodHandler,
  MessageHandler,
  MessageSession,
  MessageSessionContext,
  Server
} from "./server.js";

// Schema
export { defineSchema } from "./schema.js";
export type { TypedSchema } from "./schema.js";

// Content helpers
export {
  Image,
  Audio,
  File,
  toContentBlocks,
  fileTypeFromBuffer,
  DEFAULT_FROM_URL_MAX_BYTES,
} from "./content/index.js";
export type {
  ImageContent,
  AudioContent,
  EmbeddedResource,
  TextResourceContents,
  BlobResourceContents,
  ContentBlock,
  TextContent,
  FileTypeResult,
  FromUrlOptions,
} from "./content/index.js";
export type { ToolReturn } from "./content/index.js";

// Types
export type {
  ServerOptions,
  ToolHandler,
  ToolDefinition,
  Tool,
  ToolAnnotations,
  ToolExecution,
  Icon,
  ContentAnnotations,
  ResourceLink,
  CallToolResult,
  PromptContentItem,
  PromptArgument,
  Prompt,
  PromptMessage,
  GetPromptResult,
  PromptHandler,
  PromptDefinition,
  Resource,
  ResourceTemplate,
  ResourceContents,
  ReadResourceResult,
  ResourceHandler,
  ResourceDefinition,
  ResourceTemplateDefinition,
  HandleResult,
  ContentItem,
  JSONSchema,
  JSONSchemaProperty,
  Transport,
  SDKTransport,
  JSONRPCRequest,
  JSONRPCResponse,
  JSONRPCError,
  JSONRPCMessage,
  JSONRPCNotification,
  InitializeResult,
} from "./types.js";

export { JSON_RPC_ERROR_CODES, ToolError } from "./types.js";
